import styled from 'styled-components/macro'
import { Z_INDEX } from '../../styles/z-index'

export const NotificationContainer = styled.div<{
  stickRight?: boolean
}>`
  background: #fff;
  box-shadow:
    0px 1px 2px 0px rgba(30, 25, 25, 0.08),
    0px 2px 4px 0px rgba(30, 25, 25, 0.08),
    0px 4px 8px 0px rgba(30, 25, 25, 0.08),
    0px 8px 16px 0px rgba(30, 25, 25, 0.08),
    0px 8px 32px 0px rgba(30, 25, 25, 0.08);
  position: fixed;
  display: flex;
  top: 80px;
  left: 15px;
  bottom: calc(60px + env(safe-area-inset-bottom) + 12px);
  width: calc(100% - 30px);
  flex-direction: column;
  border-radius: 12px;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: ${Z_INDEX.NOTIFICATION};
  ${(props) => (props.stickRight ? 'right: 20px;' : '')}
`
export const NotificationHeader = styled.div<{ isMobile?: boolean }>`
  display: flex;
  padding: 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  justify-content: space-between;

  color: #191d23;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */

  svg {
    font-size: 40px;
  }
`

export const NotificationSubHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 16px 4px 16px;
  justify-content: space-between;
  align-items: center;

  color: #1a1918;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;

  & > a {
    font-size: 10px;
  }
`
